import React from "react";
import { useTranslation } from "react-i18next";
import {
  CartesianGrid,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { KeywordReviewCrossAnalysisV2Keyword } from "../../types/keywordReviewCrossAnalysisV2Data";

import "./styles.scss";

interface ISearchCountScatterplotProps {
  keywords: KeywordReviewCrossAnalysisV2Keyword[];
}

const SearchCountScatterplot: React.FunctionComponent<
  ISearchCountScatterplotProps
> = ({ keywords }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`EXPERIMENTAL_organizationFeaturesPage.v2.${key}`);

  const data = keywords.map((kw) => ({
    keyword: kw.keyword,
    review_mention_count: kw.review_mention_count,
    search_count_total: kw.search_count_total,
  }));

  return (
    <div className="keyword-review-cross-analysis-v2-scatterplot">
      <ResponsiveContainer>
        <ScatterChart {...{ overflow: "visible" }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            dataKey="review_mention_count"
            name={t("review_mentions")}
            tick={{ fontSize: 12 }}
            style={{ fontFamily: "Inter" }}
            label={{
              value: t("review_mentions"),
              position: "bottom",
              style: { fontFamily: "Inter" },
            }}
          />
          <YAxis
            type="number"
            dataKey="search_count_total"
            name={t("search_count")}
            tick={{ fontSize: 12 }}
            style={{ fontFamily: "Inter" }}
            label={{
              value: t("search_count"),
              angle: -90,
              position: "left",
              style: { fontFamily: "Inter" },
            }}
          />
          <Tooltip
            content={({ payload }) => {
              const d = payload?.[0]?.payload;
              if (!d) return null;
              return (
                <div className="keyword-review-cross-analysis-v2-scatterplot-tooltip">
                  <span className="tooltip-keyword">{d.keyword}</span>
                  <span>
                    {t("search_count")}:{" "}
                    {new Intl.NumberFormat("en").format(d.search_count_total)}
                  </span>
                  <span>
                    {t("review_mentions")}:{" "}
                    {new Intl.NumberFormat("en").format(d.review_mention_count)}
                  </span>
                </div>
              );
            }}
          />
          <Scatter data={data} fill="#3241ff" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SearchCountScatterplot;
